import { API_URL } from 'core/infra/environment'
import { HttpClient, type HttpClientConfig } from 'core/infra/http/HttpClient'

import sentry from 'legacy/utils/sentry'

import { ShipmentRepository } from '../infra/ShipmentRepository'

export type GetAgnosticShippersFactoryDependencies = {
  repository: ShipmentRepository
}

export function getAgnosticShippersFactory({ repository }: GetAgnosticShippersFactoryDependencies) {
  return async function getAgnosticShippersImpl(config?: Partial<HttpClientConfig>) {
    try {
      return await repository.getAgnosticShippers(config)
    } catch (error) {
      const newError = new Error('Failed to get agnostic shippers', { cause: error as Error })
      sentry.log(newError)
      throw newError
    }
  }
}

export function getAgnosticShippers(config?: Partial<HttpClientConfig>) {
  const httpClient = new HttpClient(API_URL)
  const repository = new ShipmentRepository({ httpClient })
  const getShippers = getAgnosticShippersFactory({ repository })

  return getShippers(config)
}
